import {makeStyles} from '@material-ui/styles';
import {merge} from 'helpers/styles';

export default makeStyles((theme) => ({
        'root': merge({
                marginRight: 'auto',
                marginLeft: 'auto',
                width: '100%',
                maxWidth: 1100,
                color: theme.palette.common.purple,
                background: theme.palette.common.darkBlue,
                '& h1': {
                    marginBottom: 15,
                    color: theme.palette.common.white,
                },
                '& h2': {
                    marginBottom: 15,
                    color: theme.palette.common.white,
                },
                '& h3': {
                    marginBottom: 15,
                    color: theme.palette.common.white,
                },
                '& h4': {
                    marginBottom: 15,
                    color: theme.palette.common.white,
                },
                '& p': merge({
                        '&:last-child': {
                            marginBottom: 0,
                        },
                        '& a': {
                            fontWeight: 'bold',
                            color: theme.palette.common.white,
                            '&:hover': {
                                [theme.breakpoints.up('sm')]: {
                                    textDecoration: 'none',
                                    color: theme.palette.common.white,
                                },
                            },
                        },
                        '& + h1, & + h2, & + h3, & + h4': {
                            marginTop: 40,
                            [theme.breakpoints.down('sm')]: {
                                marginTop: 25,
                            },
                        },
                    },
                    theme.gutter.sm.margin.bottom,
                ),
                '& ul': merge({
                        paddingLeft: 45,
                        [theme.breakpoints.down('sm')]: {
                            paddingLeft: 20,
                        },
                        '& li': {
                            marginBottom: 10,
                            '&:last-child': {
                                marginBottom: 0,
                            },
                        },
                        '&:last-child': {
                            marginBottom: 0,
                        },
                        '& + h1, & + h2, & + h3, & + h4': {
                            marginTop: 40,
                            [theme.breakpoints.down('sm')]: {
                                marginTop: 25,
                            },
                        },
                    },
                    theme.gutter.sm.margin.bottom,
                ),
                '& ol': merge({
                        paddingLeft: 25,
                        [theme.breakpoints.down('sm')]: {
                            paddingLeft: 0,
                        },
                        '& li': {
                            marginBottom: 10,
                            paddingLeft: 35,
                            position: 'relative',
                            listStyle: 'none',
                            color: theme.palette.common.white,
                            '&:nth-child(1):before': {
                                content: '"1"',
                            },
                            '&:nth-child(2):before': {
                                content: '"2"',
                            },
                            '&:nth-child(3):before': {
                                content: '"3"',
                            },
                            '&:nth-child(4):before': {
                                content: '"4"',
                            },
                            '&:nth-child(5):before': {
                                content: '"5"',
                            },
                            '&:nth-child(6):before': {
                                content: '"6"',
                            },
                            '&:nth-child(7):before': {
                                content: '"7"',
                            },
                            '&:nth-child(8):before': {
                                content: '"8"',
                            },
                            '&:nth-child(9):before': {
                                content: '"9"',
                            },
                            '&:nth-child(10):before': {
                                content: '"10"',
                            },
                            '&:last-child': {
                                marginBottom: 0,
                            },
                            '&:before': {
                                paddingBottom: 2,
                                position: 'absolute',
                                top: 1,
                                left: 0,
                                content: '""',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: 22.5,
                                height: 22.5,
                                fontSize: 12,
                                fontWeight: 'bold',
                                color: theme.palette.common.white,
                                borderRadius: '50%',
                                background: theme.palette.primary.main,
                            },
                        },
                        '&:last-child': {
                            marginBottom: 0,
                        },
                        '& + h1, & + h2, & + h3, & + h4': {
                            marginTop: 40,
                            [theme.breakpoints.down('sm')]: {
                                marginTop: 25,
                            },
                        },
                    },
                    theme.gutter.sm.margin.bottom,
                ),
                '& .align-right': {
                    margin: '0 0 25px 25px',
                    float: 'right',
                },
                '& .align-left': {
                    margin: '0 25px 25px 0',
                    float: 'left',
                },
                '& .align-center': {
                    margin: '0 auto 25px',
                    display: 'block',
                },
                '& img': {
                    maxWidth: '100%',
                    height: 'auto',
                },
            },
            theme.gutter.md.padding.all,
        ),
    }),
    {
        name: 'Content',
    },
);
